module.exports = __webpack_public_path__ + "img/ic_udl.7b35545c.svg";